module.exports = __webpack_public_path__ + "img/second_wave_top.589f54c6.svg";